/**
 * Emails of users who should see the Products filter masked as
 * "Product 1", "Product 2", … instead of real drug names (see the
 * drug_name block in src/components/filters/index.tsx). Everyone else
 * sees real product names as normal.
 */
export const DEMO_USERS: string[] = ["Foresight_Demo@elusahealth.com"];

/**
 * Whether `email` belongs to a demo account. Case-insensitive because the
 * address comes back from the API however it was typed at sign-up, while the
 * list above is written once by hand.
 */
export const isDemoUserEmail = (email: string | undefined | null): boolean =>
  !!email &&
  DEMO_USERS.some((demo) => demo.toLowerCase() === email.toLowerCase());
